import { render, staticRenderFns } from "./DCLists.vue?vue&type=template&id=688e4fdc&scoped=true"
import script from "./DCLists.vue?vue&type=script&lang=js"
export * from "./DCLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688e4fdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('688e4fdc')) {
      api.createRecord('688e4fdc', component.options)
    } else {
      api.reload('688e4fdc', component.options)
    }
    module.hot.accept("./DCLists.vue?vue&type=template&id=688e4fdc&scoped=true", function () {
      api.rerender('688e4fdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/QSPI/QspiMasterData/DCLists.vue"
export default component.exports